import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { I18NDataDto } from 'src/.api-client/models/i-18-n-data-dto';
import { FrontendConfigApiService } from 'src/.api-client/services/frontend-config-api.service';
import { AbstractCache } from './abstract-cache';

@Injectable({ providedIn: 'root' })
export class I18nDataCache extends AbstractCache<I18NDataDto['data']> {
    constructor(private _frontendConfigApiService: FrontendConfigApiService) {
        super();
    }

    protected _getCurrentValue() {
        return this._frontendConfigApiService.i18NGetI18NData().pipe(map(({ data }) => data));
    }
}
